import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PendingRequestsService {
  private pendingRequests = 0;
  public pending$ = new BehaviorSubject<boolean>(false);

  addRequest() {
    this.pendingRequests++;
    this.pending$.next(true);
  }

  removeRequest() {
    this.pendingRequests = Math.max(0, this.pendingRequests - 1);
    this.pending$.next(this.pendingRequests > 0);
  }
}